<template>
  <div id="payment-required-banner">
   <a href="team/?tab=4">
     <div class="payment-required-text">
      {{ $t('paymentRequiredBanner.text', { date: formattedValidUntil }) }}
    </div>
   </a>
  </div>
</template>

<script>
export default {
  name: 'PaymentRequiredBanner',
  props: {
    paymentStatus: Object,
  },
  computed: {
    formattedValidUntil() {
      return this.$moment(this.paymentStatus.validUntil).format('MMMM D');
    },
  },
};
</script>

<style lang="scss" scoped>
#payment-required-banner {
  height: 50px;
  width: 100%;
  background-color: $secondary-color;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  .payment-required-text {
    color: #fff;
  }
}
</style>